const actions = {
  REQUESTING: 'Invoice2Lines/REQUESTING',
  RESPONSE_ERROR: 'Invoice2Lines/RESPONSE_ERROR',

  FETCH_INVOICE2LINES: 'Invoice2Lines/FETCH',
  LIST_INVOICE2LINE: 'Invoice2Line/LIST',

  FETCH_INVOICE2LINE: 'Invoice2Line/FETCH',
  NEW_INVOICE2LINE: 'Invoice2Line/NEW',
  EDIT_INVOICE2LINE: 'Invoice2Line/EDIT',
  RESET_INVOICE2LINE: 'Invoice2Line/RESET',

  RE_FETCH_INVOICE2LINES: 'Invoice2Lines/REFRESH',
  SAVE_INVOICE2LINE: 'Invoice2Line/SAVE',
  SAVE_INVOICE2LINE_RECIEVED: 'Invoice2Line/SAVE_INVOICE2LINE_RECIEVED',

  DELETE_INVOICE2LINE: 'Invoice2Line/DELETE',
  DELETE_INVOICE2LINE_RECIEVED: 'Invoice2Line/DELETE_RECIEVED',

  // Text lines added while the invoice itself is not saved yet (invoiceID 0):
  // kept locally and flushed to the API right after the invoice is created.
  ADD_PENDING_INVOICE2LINE: 'Invoice2Line/ADD_PENDING',
  REMOVE_PENDING_INVOICE2LINE: 'Invoice2Line/REMOVE_PENDING',
  CLEAR_PENDING_INVOICE2LINES: 'Invoice2Line/CLEAR_PENDING',
}

export default actions
